import { label, primary } from 'styles'

import { makeStyles } from '@mui/styles'

interface ThemeProps {
  padding: string
}

export default makeStyles({
  icon: {
    '&&': {
      fontSize: '1.5rem',
      marginRight: '0.5rem',
      padding: '0',
    },
  },
  message: {
    '&&': {
      fontSize: '1rem',
      lineHeight: '1rem',
      padding: '0',
    },
  },
  refresh: {
    color: primary,
  },
  root: {
    '&&': {
      alignItems: 'center',
      backgroundColor: 'initial',
      display: 'flex',
      padding: ({ padding }: ThemeProps) => padding,
    },
  },
  text: {
    color: label,
  },
})
